import classNames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import { branch, compose, lifecycle, renderComponent } from 'recompose';
import { bindActionCreators } from 'redux';
import { routes, tabKeys } from '../../constants';
import logo from '../../images/logo.png';
import { isPendingUser } from '../../services';
import { cpdCategorysActions } from '../../state/modules/areas-of-advice';
import { cpdPointActions } from '../../state/modules/cpd-points';
import { industryActions } from '../../state/modules/industry';
import { systemStatusActions } from '../../state/modules/system-status';
import { currentUserIdSelector, currentUserRoleSelector, currentUserSelector, userActions } from '../../state/modules/user';
import FullScreenLoading from '../pages/full-screen-loading';
import { AppNav, Footer, NoMatchNav } from '../partials';
import {
  AllTeamMembers,
  Bookmark,
  BusinessContentHome,
  BusinessLibrary,
  BusinessLibraryCompletedContent,
  BusinessLibraryContent,
  BusinessLibraryContentDetails,
  BusinessLibraryContentQuestion,
  BusinessUserQualificationDetail,
  ChooseCpdAllocation,
  ChooseTaskType,
  CompletedTasks,
  ConfirmAcceptInvitation,
  ContentQuiz,
  CpdActivity,
  Dashboard,
  EventCpdCategory,
  EventHome,
  EventRedirect,
  ExternalCpdDetails,
  ExternalCpdReview,
  GoalHome,
  IndividualReport,
  Info,
  MemberSnapshotReport,
  NoMatch,
  ProfessionalProfile,
  QualificationDetail,
  TaskDetails,
  TaskEdit,
  TaskReview,
  Tasks,
  TaskView,
  TeamCreate,
  TeamEdit,
  TeamMemberReport,
  TeamMembers,
  TeamProgressReport,
  Teams,
  TeamSettings,
  TeamUserAccountSettings,
  TeamUserCpdActivity,
  TeamUserProfessionalProfile,
  TechnicalHome,
  TrainingCpdCategory,
  TrainingHome,
  TrainingPlansSettings,
  UnassignedTeamMembers,
  UserAccountSettings,
  UserNotFound,
  UsersAndTeamsSettings,
  UserSnapshotProgressReport
} from '../pages';


const withNavBar = (Component, additionalProps) => (props) => (
  <div className='clearfix'>
    <AppNav {...additionalProps} />
    <Component {...props} />
  </div>
);

const withFooter = (className) => (Component) => (props) => (
  <div className={classNames('clearfix', className)}>
    <Component {...props} />
    <Footer logo={logo} />
  </div>
);

/**
 * Main application layout component.
 */
const App = () => (
  <div className='clearfix content-body'>
    <Switch>
      <Route exact path={routes.app.dashboard} component={withNavBar(Dashboard)} />
      <Route exact path={routes.app.trainingPlansSettings(':tab')} component={withNavBar(TrainingPlansSettings)} />
      <Route exact path={routes.app.trainingPlansSettings()} component={() => <Redirect to={routes.app.trainingPlansSettings(tabKeys.trainingPlansSettings.userTrainingPlan)} />} />
      <Route exact path={routes.app.usersAndTeamsSettings(':tab')} component={withNavBar(UsersAndTeamsSettings)} />
      <Route exact path={routes.app.accountSettings(':tab')} component={withNavBar(UserAccountSettings)} />
      <Route exact path={routes.app.accountSettings()} component={() => <Redirect to={routes.app.accountSettings(tabKeys.accountSettings.personalDetail)} />} />
      <Route exact path={routes.app.info} component={withNavBar(Info)} />
      <Route exact path={routes.app.confirmAcceptInvitation} component={withNavBar(ConfirmAcceptInvitation)} />
      <Route exact path={routes.app.training.home} component={withNavBar(TrainingHome)} />
      <Route exact path={routes.app.training.technicalHome} component={withNavBar(TechnicalHome)} />
      <Route exact path={routes.app.training.eventHome} component={withNavBar(EventHome)} />
      <Route exact path={routes.app.training.businessContentHome} component={withNavBar(BusinessContentHome)} />
      <Route exact path={routes.app.training.bookmark} component={withNavBar(Bookmark)} />
      <Route exact path={routes.app.training.goal(':goalId')} component={withNavBar(GoalHome)} />
      <Route exact path={routes.app.training.cpdCategory(':cpdCategoryId')} component={withNavBar(TrainingCpdCategory)} />
      <Route exact path={routes.app.training.eventCpdCategory(':cpdCategory')} component={withNavBar(EventCpdCategory)} />
      <Route exact path={routes.app.training.content} component={withNavBar(ContentQuiz, { showCloseNav: true, routeAfterClose: routes.app.training.home, closeBtnText: 'Return to Caddie' })} />
      <Route exact path={routes.app.training.nonCpdContent} component={withNavBar(ContentQuiz, { showCloseNav: true, routeAfterClose: routes.app.training.businessContentHome, closeBtnText: 'Return to Caddie' })} />
      <Route exact path={routes.app.training.contentAlt(":contentId")} component={withNavBar(ContentQuiz, { showCloseNav: true, routeAfterClose: routes.app.training.home, closeBtnText: 'Return to Caddie' })} />
      <Route exact path={routes.app.training.event} component={withNavBar(EventRedirect, { showCloseNav: true, routeAfterClose: routes.app.training.home, closeBtnText: 'Return to Caddie' })} />
      <Route exact path={routes.app.tasks.home} component={withNavBar(Tasks)} />
      <Route exact path={routes.app.tasks.chooseTaskType} component={withNavBar(ChooseTaskType)} />
      <Route exact path={routes.app.tasks.chooseCpdAllocation} component={withNavBar(ChooseCpdAllocation)} />
      <Route exact path={routes.app.tasks.details} component={withNavBar(TaskDetails)} />
      <Route exact path={routes.app.tasks.review} component={withNavBar(TaskReview)} />
      <Route exact path={routes.app.tasks.view(':taskId')} component={withNavBar(TaskView)} />
      <Route exact path={routes.app.tasks.edit(':taskId')} component={withNavBar(TaskEdit)} />
      <Route exact path={routes.app.library.root} component={withNavBar(BusinessLibrary)} />
      <Route exact path={routes.app.library.content} component={withNavBar(BusinessLibraryContent)} />
      <Route exact path={routes.app.library.completedContent} component={withNavBar(BusinessLibraryCompletedContent)} />
      <Route path={routes.app.library.contentDetails} component={withNavBar(BusinessLibraryContentDetails)} />
      <Route path={routes.app.library.contentQuestion} component={withNavBar(BusinessLibraryContentQuestion)} />
      <Route exact path={routes.app.professionalProfile.root} component={withNavBar(ProfessionalProfile)} />
      <Route exact path={routes.app.professionalProfile.cpdActivity} component={withNavBar(CpdActivity)} />
      <Route exact path={routes.app.professionalProfile.completedTasks} component={withNavBar(CompletedTasks)} />
      <Route exact path={routes.app.professionalProfile.progressReport} component={withNavBar(IndividualReport)} />
      <Route exact path={routes.app.professionalProfile.snapshotProgressReport(':snapshotId')} component={withNavBar(UserSnapshotProgressReport)} />
      <Route exact path={routes.app.professionalProfile.content} component={withNavBar(ContentQuiz, { showCloseNav: true, routeAfterClose: routes.app.professionalProfile.root, closeBtnText: 'Return to Caddie' })} />
      <Route exact path={routes.app.professionalProfile.businessUserQualificationDetail(':businessId', ':userId', ':qualificationId')} component={withNavBar(BusinessUserQualificationDetail)} />
      <Route exact path={routes.app.professionalProfile.qualificationEdit(':qualificationId')} component={withNavBar(QualificationDetail)} />
      <Route exact path={routes.app.professionalProfile.qualificationDetail} component={withNavBar(QualificationDetail)} />
      <Route exact path={routes.app.externalCpd.details} component={withNavBar(ExternalCpdDetails)} />
      <Route exact path={routes.app.externalCpd.registerEvent(':eventId')} component={withNavBar(ExternalCpdDetails)} />
      <Route exact path={routes.app.externalCpd.detailsReview(':externalCpdId', ':userId')} component={withNavBar(ExternalCpdDetails)} />
      <Route exact path={routes.app.externalCpd.detailsEdit(':externalCpdId')} component={withNavBar(ExternalCpdDetails)} />
      <Route exact path={routes.app.externalCpd.review} component={withNavBar(ExternalCpdReview)} />
      <Route exact path={routes.app.externalCpd.reviewTeam(':teamId')} component={withNavBar(ExternalCpdReview)} />
      <Route exact path={routes.app.externalCpd.reviewTeamMember(':teamId', ':userId')} component={withNavBar(ExternalCpdReview)} />
      <Route exact path={routes.app.teams.root} component={withNavBar(Teams)} />
      <Route exact path={routes.app.teams.allTeamMembers} component={withNavBar(AllTeamMembers)} />
      <Route exact path={routes.app.teams.unassignedTeamMembers} component={withNavBar(UnassignedTeamMembers)} />
      <Route exact path={routes.app.teams.teamMembers(':businessTeamId')} component={withNavBar(TeamMembers)} />
      <Route exact path={routes.app.teams.teamEdit(':businessTeamId')} component={withNavBar(TeamEdit)} />
      <Route exact path={routes.app.teams.newTeam} component={withNavBar(TeamCreate)} />
      <Route exact path={routes.app.teams.teamMemberSettings(':team', ':user', ':tab')} component={withNavBar(TeamUserAccountSettings)} />
      <Route exact path={routes.app.teams.teamMemberSettings(':team', ':user')} component={({ match: { params: { team, user } } }) => <Redirect to={routes.app.teams.teamMemberSettings(team, user, tabKeys.businessUserSettings.trainingPlan)} />} />
      <Route exact path={routes.app.teams.teamMemberProfiles(':team', ':user')} component={withNavBar(TeamUserProfessionalProfile)} />
      <Route exact path={routes.app.teams.userSnapshotReport(':userId', ':snapshotId')} component={withNavBar(MemberSnapshotReport)} />
      <Route exact path={routes.app.teams.teamMemberCpdActivity(':team', ':user')} component={withNavBar(TeamUserCpdActivity)} />
      <Route exact path={routes.app.teams.teamMemberReport(':team', ':user')} component={withNavBar(TeamMemberReport)} />
      <Route exact path={routes.app.teams.allTeamMemberReport(':user')} component={withNavBar(TeamMemberReport)} />
      <Route exact path={routes.app.teams.singleTeamProgressReport(':teamId')} component={withNavBar(TeamProgressReport)} />
      <Route exact path={routes.app.teams.allTeamProgressReport} component={withNavBar(TeamProgressReport)} />
      <Route exact path={routes.app.teams.userSettings(':user', ':tab')} component={withNavBar(TeamUserAccountSettings)} />
      <Route exact path={routes.app.teams.userSettings(':user')} component={({ match: { params: { user } } }) => <Redirect to={routes.app.teams.userSettings(user, tabKeys.businessUserSettings.trainingPlan)} />} />
      <Route exact path={routes.app.teams.userProfiles(':user')} component={withNavBar(TeamUserProfessionalProfile)} />
      <Route exact path={routes.app.teams.userCpdActivity(':user')} component={withNavBar(TeamUserCpdActivity)} />
      <Route exact path={routes.app.teams.teamSettings(':user', ':tab')} component={withNavBar(TeamSettings)} />
      <Route exact path={routes.app.teams.teamSettings(':user')} component={({ match: { params: { user } } }) => <Redirect to={routes.app.teams.teamSettings(user, tabKeys.businessTeamSettings.trainingPlan)} />} />
      <Route exact path={routes.app.userNotFound} component={() => [
        <NoMatchNav key='404-nav' />,
        <UserNotFound key='user-not-found-page' />
      ]} />
      <Route component={() => [
        <NoMatchNav key='404-nav' />,
        <NoMatch key='404-page' />
      ]} />
    </Switch>
  </div>
);

const mapStateToProps = (state) => ({
  isAuthenticated: state.session.isAuthenticated,
  isFetchingUserData: state.user.isFetchingUserData,
  isFetchingUserRole: state.user.currentUserIndustryRoleIsFetching,
  isFetchingBusiness: state.business.isFetching,
  currentUser: currentUserSelector(state),
  userId: currentUserIdSelector(state),
  userRole: currentUserRoleSelector(state),
  systemProfile: state.systemStatus.profile
});

const mapDispatchToProps = (dispatch) => ({
  getCpdCategorys: bindActionCreators(userActions.user.getCpdCategorys, dispatch),
  getCpdPoints: bindActionCreators(cpdPointActions.cpdPoints.get, dispatch),
  getUser: bindActionCreators(userActions.user.getCurrent, dispatch),
  getUserIndustryRoles: bindActionCreators(userActions.user.getIndustryRoles, dispatch),
  getAllCpdCategorys: bindActionCreators(cpdCategorysActions.cpdCategorys.get, dispatch),
  getIndustriesWithCpdCategorys: bindActionCreators(industryActions.industries.industriesWithCpdCategorys, dispatch),
  getSystemProfile: bindActionCreators(systemStatusActions.systemStatus.profile, dispatch)
});

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  branch(
    ({ isAuthenticated }) => !isAuthenticated,
    renderComponent(() => (
      <Redirect to={routes.login} />
    ))
  ),
  lifecycle({
    componentDidMount() {
      this.props.getUser();
      this.props.getUserIndustryRoles();
      this.props.getCpdCategorys();
      this.props.getAllCpdCategorys();
      this.props.getIndustriesWithCpdCategorys();
      this.props.getSystemProfile();
    }
  }),
  branch(
    ({
      isFetchingUserData,
      isFetchingUserRole,
      isFetchingBusiness,
      systemProfile
    }) => isFetchingUserData || isFetchingUserRole || isFetchingBusiness || !systemProfile,
    renderComponent(withNavBar(FullScreenLoading))
  ),
  branch(
    ({
      isFetchingUserData,
      userId,
      userRole
    }) => userId && !isFetchingUserData && isPendingUser({ roleAssignments: userRole }),
    renderComponent(() => (
      <Redirect to={routes.onboarding.billing} />
    ))
  )
)(withFooter('app')(App));



// WEBPACK FOOTER //
// ./src/containers/layouts/app.js